/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Review_PendingInputs */



/**
* | output |
* | --- |
* | "An admin review is required. If no review is submitted, the chat will be kept blocked." |
*
* @param {Audit_Details_Review_PendingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_review_pending = /** @type {((inputs?: Audit_Details_Review_PendingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Review_PendingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Eintrag erfordert eine Admin-Überprüfung, bevor der Chat entsperrt werden kann.")
	return /** @type {LocalizedString} */ ("An admin review is required. If no review is submitted, the chat will be kept blocked.")
});